import Test from   "../../Images/testimony.jpg"


export const  ConfessionList = [
    {
        image: Test,

        confession: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque, totam. Deserunt corrupti id accusantium? Blanditiis deleniti commodi, quam culpa distinctio velit voluptas voluptate incidunt totam, quidem eligendi, ex repudiandae ipsam?',
        name:'Mathew Johnson',
        occupation: 'Carpenter'
    },
    {
        image: Test,
        confession: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque, totam. Deserunt corrupti id accusantium? Blanditiis deleniti commodi, quam culpa distinctio velit voluptas voluptate incidunt totam, quidem eligendi, ex repudiandae ipsam?',
        name:'Mathew Johnson',
        occupation: 'Carpenter'
    },
    {
        image: Test ,
        confession: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque, totam. Deserunt corrupti id accusantium? Blanditiis deleniti commodi, quam culpa distinctio velit voluptas voluptate incidunt totam, quidem eligendi, ex repudiandae ipsam?',
        name:'Mathew Johnson',
        occupation: 'Carpenter'
    },
    {
        image: Test ,
        confession: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque, totam. Deserunt corrupti id accusantium? Blanditiis deleniti commodi, quam culpa distinctio velit voluptas voluptate incidunt totam, quidem eligendi, ex repudiandae ipsam?',
        name:'Mathew Johnson',
        occupation: 'Carpenter'
    },
    {
        image: Test ,
        confession: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque, totam. Deserunt corrupti id accusantium? Blanditiis deleniti commodi, quam culpa distinctio velit voluptas voluptate incidunt totam, quidem eligendi, ex repudiandae ipsam?',
        name:'Mathew Johnson',
        occupation: 'Carpenter'
    },
    {
        image: Test ,
        confession: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque, totam. Deserunt corrupti id accusantium? Blanditiis deleniti commodi, quam culpa distinctio velit voluptas voluptate incidunt totam, quidem eligendi, ex repudiandae ipsam?',
        name:'Mathew Johnson',
        occupation: 'Carpenter'
    },
    {
        image: Test ,
        confession: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque, totam. Deserunt corrupti id accusantium? Blanditiis deleniti commodi, quam culpa distinctio velit voluptas voluptate incidunt totam, quidem eligendi, ex repudiandae ipsam?',
        name:'Mathew Johnson',
        occupation: 'Carpenter'
    },
    {
        image: Test ,
        confession: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque, totam. Deserunt corrupti id accusantium? Blanditiis deleniti commodi, quam culpa distinctio velit voluptas voluptate incidunt totam, quidem eligendi, ex repudiandae ipsam?',
        name:'Mathew Johnson',
        occupation: 'Carpenter'
    },
]